import type { AxiosResponse } from 'axios';

export const pollingPropsDefaults = {
	fetchCsv: (): Promise<AxiosResponse> => Promise.resolve({} as AxiosResponse),
	filenameTitle: 'downloadCsv',
	generateCsv: (): Promise<void> => Promise.resolve(),
	queryKey: ['downloadCsv'],
};
